import instance from 'api';
import { AxiosError, AxiosResponse } from 'axios';
import { ApiResponse, BaseApi } from 'baseApi';
import { endpoints } from 'endpoints.config';
import { OptionsRequest, OptionsResponse, PackagePromo } from 'subscriptionOptions/types';
import { NewSubscriptionParser } from 'pages/newSubscription/models';

const UNKNOWN_ERROR_MESSAGE = 'Sorry, something went wrong. Please try again.';

export class NewSubscriptionApi extends BaseApi {
  // get selectable subscription options, unanchored
  public static getOptions = async (payload: OptionsRequest): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<OptionsResponse>> = await instance.post(endpoints.subscriptions.options, payload);

      if (NewSubscriptionApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return NewSubscriptionApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = NewSubscriptionParser.parseError(errors);
          return NewSubscriptionApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      const errors = error.response && error.response.data ? error.response.data.errors : null;
      if (Array.isArray(errors) && errors.length > 0) {
        const message = NewSubscriptionParser.parseError(errors);
        return NewSubscriptionApi.errorResponse(message);
      }
      return NewSubscriptionApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  };

  public static subscribeByInvoice = async (
    packagePromos: PackagePromo[],
    total: number,
    poNumber: string,
    FinanceEmail: string,
    values: any,
    addSecondSchoolUser: boolean | null,
    chooseAddOrUpgrade: boolean | null,
    addSecondUserType: string,
  ): Promise<any> => {
    try {
      const payload = NewSubscriptionParser.buildArchiveNowPayload(
        packagePromos,
        total,
        poNumber,
        FinanceEmail,
        values,
        addSecondSchoolUser,
        chooseAddOrUpgrade,
        addSecondUserType,
      );

      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.subscriptions.subscribebyinvoice,
        payload
      );

      if (NewSubscriptionApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        if (data.status === 'Success' || data.status === 'succeeded') {
          return NewSubscriptionApi.successResponse(data);
        } else {
          throw new Error();
        }
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = NewSubscriptionParser.parseError(errors);
          return NewSubscriptionApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          const message = NewSubscriptionParser.parseError(errors);
          return NewSubscriptionApi.errorResponse(message);
        }
      }
      return NewSubscriptionApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  };

  public static subscribeByCard = async (
    packagePromos: PackagePromo[],
    total: number,
    token: any,
    poNumber: string,
    FinanceEmail: string,
    secondUserDetails: any,
    secondExistingUserDetails: any,
    addOrUpgradeUserDetails: any,
  ): Promise<any> => {
    try {
      const payload = NewSubscriptionParser.buildUpgradeByCardPayload(
        packagePromos,
        total,
        token,
        poNumber,
        FinanceEmail,
        secondUserDetails,
        secondExistingUserDetails,
        addOrUpgradeUserDetails,
      );

      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.subscriptions.subscribeByCard,
        payload
      );

      if (NewSubscriptionApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return NewSubscriptionApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = NewSubscriptionParser.parseError(errors);
          return NewSubscriptionApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          const message = NewSubscriptionParser.parseError(errors);
          return NewSubscriptionApi.errorResponse(message);
        }
      }
      return NewSubscriptionApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  };

  public static updateAfter3DSecure = async (values: any): Promise<any> => {
    try {
      const payload =
        NewSubscriptionParser.buildUpdateAfter3DSecurePayload(values);
      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.subscriptions.updatAfter3DSecure,
        payload
      );

      if (NewSubscriptionApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return NewSubscriptionApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = NewSubscriptionParser.parseError(errors);
          return NewSubscriptionApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          const message = NewSubscriptionParser.parseError(errors);
          return NewSubscriptionApi.errorResponse(message);
        }
      }
      return NewSubscriptionApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  };
}
